<template>
  <div class="faq-page">
    <page-header
      :title="pageTitle"
      class="page-header--personal-data-profile mt-4"
      textLight
    />
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mb-4 mb-lg-0" v-if="visibleMenu">
          <collapse-menu
            class="d-lg-none"
            :initial-item="activeMenuItem"
            :items="menuList"
            @click="loadItems"
          />
          <nav class="d-none d-lg-block profile-navigation">
            <vl-button
              class="mb-2 w-100"
              size="large"
              v-for="(item, index) in menuList"
              :type="item.url == activeMenuItem.url ? 'menu-active' : 'menu'"
              :key="index"
              @click.native="loadItems(item)"
            >
              <span v-html="item.name" />
            </vl-button>
          </nav>
        </div>
        <div class="col-24 col-lg-17 offset-lg-1">
          <div class="faq-page__inner">
            <h3 class="h3-title h3-title--bold">
              {{ pageTitle }}
            </h3>
            <vl-accordion>
              <vl-accordion-item v-for="(item, index) in items" :key="item.id">
                <template #title>
                  <span v-html="renderTitleWithIndex(item.title, index)"></span>
                </template>
                <template #description>
                  <div v-html="item.content"></div>
                </template>
              </vl-accordion-item>
            </vl-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import VlAccordion from '@components/@tehnobank/ui/vl-accordion/VlAccordion'
import VlAccordionItem from '@components/@tehnobank/ui/vl-accordion/VlAccordionItem'
import PageHeader from '@components/@tehnobank/page-header'
import MenuProfile from '@javascript/pages/profile/menu-profile/tehnobank/MenuProfile'
import CollapseMenu from '@components/@tehnobank/collapse-menu-v2'
import VlButton from '@components/@tehnobank/ui/vl-button'
export default {
  name: 'FaqPage',
  components: {
    VlAccordion,
    VlAccordionItem,
    PageHeader,
    MenuProfile,
    CollapseMenu,
    VlButton,
  },
  props: {
    pageTitle: {
      type: String,
      default: 'Вопросы и ответы',
    },
    menuList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      items: [],
      activeMenuItem: this.menuList[0],
    }
  },
  computed: {
    ...mapGetters('faq', ['getItems']),
    visibleMenu() {
      return !!this.menuList && !!this.menuList.length
    },
  },
  methods: {
    ...mapActions({
      getFaqListItems: 'faq/API_GET_FAQ_LIST_ITEMS',
    }),
    async loadItems(item) {
      this.activeMenuItem = item
      await this.getFaqListItems(item.url)
      this.uploadItemsFromStore(item.url)
    },
    uploadItemsFromStore(url) {
      this.items = this.getItems(url)
    },
    renderTitleWithIndex(title, index = 1) {
      return `${index + 1}. ${title}`
    },
  },
  created() {
    this.loadItems(this.activeMenuItem)
  },
}
</script>
